import { prep } from './initial/flow';

const prepFlows = { prep };

export default prepFlows;
